// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"23cc1829","247":"23cc1829","358":"23cc1829","422":"23cc1829","479":"23cc1829","734":"23cc1829","918":"23cc1829","934":"23cc1829"}[chunkId] + ".chunk.css";
};